import { IconChevronDown } from '../icons';
import { useRaces } from '../contexts/races';
import { envelopeData } from '../../core/network/envelope';

import '../styles/race-select.css';

// TSS vite/01 — selector de raza compartido (public-races.md, Q-124).
// Alimentado por useRaces (catálogo global, envelope view "races"). Mismo
// patrón que FarmSelect: el error (borde --error) lo controla el form; el
// mensaje lo pinta el <Field> que lo envuelve. Devuelve number|null (race_id
// es FK int en el contrato de propuestas).
export default function RaceSelect({ value, onChange, error = false, allowEmpty = true, disabled = false }) {
    const { data, isLoading, isError } = useRaces();
    const races = envelopeData(data).items ?? [];

    return (
        <div className="race-select">
            <select
                className={`race-select__control ${error ? 'race-select__control--error' : ''}`}
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
                disabled={disabled || isLoading || isError}
            >
                {allowEmpty && (
                    <option value="">
                        {isLoading ? 'Cargando razas…' : isError ? 'No se pudo cargar el catálogo' : 'Selecciona una raza'}
                    </option>
                )}
                {races.map((race) => (
                    <option key={race.id} value={race.id}>
                        {race.name}{race.code ? ` (${race.code})` : ''}
                    </option>
                ))}
            </select>
            <span className="race-select__chevron" aria-hidden="true"><IconChevronDown /></span>
        </div>
    );
}
